
export default{
    //保存用户信息
    saveInfo({commit}, {userName, roles, leaderFirst, staffCode, staffStatus}) {
        commit('setUserName', userName);
        commit('setRoles', roles); 
        commit('setLeaderFirst', leaderFirst); 
        commit('setStaffCode', staffCode); 
        commit('setStaffStatus', staffStatus)
    },
    /**
     * 保存面包屑数组到状态管理中
     * 
     * @param {Object} context - Vuex的上下文对象，用于提交(commit)状态更新
     * @param {Array} crumbsArr - 包含面包屑信息的数组，用于更新状态中的面包屑数据
     */
    saveCrumbs({commit},crumbsArr){
        commit('setCrumbsArr', crumbsArr);
    },
    //储存跳转路由
    saveJumpMenu({commit},JumpMenu){
        commit('setJumpMenu', JumpMenu);
    },
    //储存菜单列表
    saveMenu({commit},menu){
        commit('setMenu', menu);
    },
    //储存菜单ur;
    saveLogUrl({commit},logUrl){
        commit('setLogUrl', logUrl);
    },
    //获取菜单的width;
    saveMenuWidth({commit},menuWidth){
        commit('setMenuWidth', menuWidth);
    },
    //获取页面的按钮;
    saveButtons({commit},buttons){
        commit('setButtons', buttons);
    },
    //获取tokens;
    saveTokens({commit},tokens){
        commit('setTokens', tokens);
    },

    //Tabs视图
    saveVisitedViews({commit},visitedViews){
      commit('setVisitedViews', visitedViews);
    },
    //缓存
    saveCachedViews({commit},cachedViews){
      commit('setCachedViews', cachedViews);
    },
    //路由表
    saveRouteList({commit},routeList){
        commit('setRouteList', routeList);
    },
    saveJumpParams({commit},JumpParams){
        commit('setJumpParams', JumpParams);
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js